module.exports = __webpack_public_path__ + "img/ggg.6745f9a8.png";